import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=34870180&scoped=true&"
import script from "./questions.vue?vue&type=script&lang=js&"
export * from "./questions.vue?vue&type=script&lang=js&"
import style0 from "./questions.vue?vue&type=style&index=0&id=34870180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34870180",
  null
  
)

export default component.exports